import React from 'react';
import '../styles/Modal.css';
import { useTranslation } from '../context/TranslationContext';

const ModalInfo = ({ isOpen, onClose, onAction, updateType}) => {
    const { t } = useTranslation();

  if (!isOpen) return null;

  const handleCancel = () => {
    onAction('cancel');
    onClose();
  };

  const handleUpdate = () => {
    onAction('update');
    onClose();
  };

  const titleKey = updateType === 'phone' ? 'profile.phoneUpdateTitle' : 'profile.emailUpdateTitle';
  const messageKey = updateType === 'phone' ? 'profile.phoneUpdateMessage' : 'profile.emailUpdateMessage';


  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <button className="modal-close-button" onClick={onClose}>×</button>
        <div className='modal-content'>
        <p><strong>{t(titleKey)}</strong><br />
            {t(messageKey)}</p>
        <div className="modal-buttons">
            <button className="modal-button cancel" onClick={handleCancel}>{t('cancel')}</button>
            <button className="modal-button update" onClick={handleUpdate}>{t('update')}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalInfo;
